import React from 'react';
import styles from './Resume.module.scss';
import { AiOutlineGithub, AiOutlineGlobal, AiOutlineHome, AiOutlineLinkedin, AiOutlineMail, AiOutlinePhone } from 'react-icons/ai';

export const ResumeHeader = ({ ...props }) => {
    return (
        <header {...props} className={`${styles.header} sticky`}>
            <div className={styles.headerName}>
                <h1>Burak Bal</h1>
                <p data-testid='headerJobTitle'>{process.env.REACT_APP_FRONTEND_RESUME ? 'Senior Frontend Engineer' : 'DevOps Engineer'}</p>
            </div>
            <address className={styles.headerInfo} aria-label='Contact information'>
                <div>
                    <span>Istanbul, Turkey</span>
                    <AiOutlineHome aria-hidden='true' />
                </div>
                <div>
                    <span>+90 538 505 8239</span>
                    <AiOutlinePhone aria-hidden='true' />
                </div>
                <a href='mailto:burakbal1296@gmail.com'>
                    <span>burakbal1296@gmail.com</span>
                    <AiOutlineMail aria-hidden='true' />
                </a>
                <a href='https://burakbal.com' target='_blank' rel='noreferrer'>
                    <span>burakbal.com</span>
                    <AiOutlineGlobal aria-hidden='true' />
                </a>
                <a href='https://github.com/BurakBal96' target='_blank' rel='noreferrer'>
                    <span>GitHub: /BurakBal96</span>
                    <AiOutlineGithub aria-hidden='true' />
                </a>
                <a href='https://www.linkedin.com/in/burak-bal/' target='_blank' rel='noreferrer'>
                    <span>LinkedIn: /in/burak-bal</span>
                    <AiOutlineLinkedin aria-hidden='true' />
                </a>
            </address>
        </header>
    );
};
